<template>
  <transition name="slide">
    <v-alert :type="options.type" class="flash-container" :style="transitionStyle">
      {{ options.text }}
    </v-alert>
  </transition>
</template>

<script>
import { mapState, mapActions } from "vuex";

const marginTop = 50;
const flashMassageHeight = 62;
const spaceBetweenFlashMessages = 8;

export default {
  name: "banner",
  props: {
    options: {
      type: Object,
    },
    position: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      enablePosition: false,
    };
  },
  computed: {
    ...mapState(["banners"]),
    transitionStyle() {
      return {
        transform: `translateY(${
          this.enablePosition
            ? marginTop +
              (flashMassageHeight + spaceBetweenFlashMessages) * this.position
            : -(flashMassageHeight + spaceBetweenFlashMessages)
        }px)`,
      };
    },
  },
  methods: {
    ...mapActions(["removeBanner"]),

    removeSelf() {
      this.enablePosition = false;
      this.$nextTick(() => this.removeBanner(this.options));
    },
  },
  mounted() {
    if (this.options) {
      setTimeout(() => (this.enablePosition = true));
      setTimeout(() => this.removeSelf(), this.options.time);
    }
  },
};
</script>

<style>
.banner {
  z-index: 9999;
  position: absolute;
}

.flash-container {
  align-items: center;
  z-index: 99999999999;
  top: 0;
  transition: transform 0.3s;
  margin-right: 16px;
  right: 0;
  width: 30%;
  left: unset;
  align-self: center;
}
</style>
